import Utils from '../Common/Utils.js';

// Temperature is stored as {"temperature":X,"color":Y}. Be tolerant of a bare
// number value (legacy rows / other seeders) so it never renders as "NaN":
// pull `.temperature` when present, otherwise parse the value itself.
const parseTemperatureValue = (raw) => {
    let parsed;
    try { parsed = JSON.parse(raw); } catch (e) { return Number.parseFloat(raw); }
    if (parsed !== null && typeof parsed === 'object' && parsed.temperature !== undefined) {
        return Number.parseFloat(parsed.temperature);
    }
    return Number.parseFloat(parsed);
}

//Function to set temperature data & color depending on connection state
const getLastTemperatureDataAndColor = (dataset, threshold, threshold2) => {

	let temperatureData = {
        temperature: "-",
        color: "#767676"
	}

    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set temperature val
        temperatureData.temperature = dataset[dataset.length-1].y.toFixed(1)
        //Set temperature val color
        if ((temperatureData.temperature >34.7)&&(temperatureData.temperature <42.00)){
            if (threshold2 === null || threshold2 === undefined) {
                threshold2 = Utils.setDefaultThreshold2("temperature")
            }
            temperatureData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 1.00, 'sup', threshold2);
        }
    }

	return (temperatureData);
}


const formatAndMergeTemperatureData = (fullLoad, oldData, newData) => {

    let local_data = [];
    let isANewDateValue = "";

    // Reset data if new load
    if (fullLoad){
        oldData = []
    }

    if (oldData !== undefined){
        Utils.mergeBasicOldData(oldData, local_data)
            }                                              
    
    if (newData !== undefined){
        if(newData.length !== 0){
            for (var i = newData.length-1; i >= 0; i--){        // Find new values and add it
                isANewDateValue = local_data.find(xDate => { return xDate.x === new Date(newData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){
                    local_data.push({x: new Date(newData[i].eventDate).getTime(), y: parseTemperatureValue(newData[i].value)});
                }
            }
        }
    }
    return local_data;
}

const formatAndMergeBatorPosData = (fullLoad, oldData, newData) => {

    let local_data = [];
    let isANewDateValue = "";

    // Reset data if new load
    if (fullLoad){
        oldData = []
    }
    
    if (oldData !== undefined){
        Utils.mergeBasicOldData(oldData, local_data)
    }
    
    if (newData !== undefined){
        if(newData.length !== 0){
            for (var i = newData.length-1; i >= 0; i--){        // Find new values and add it
                isANewDateValue = local_data.find(xDate => { return xDate.x === new Date(newData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){
                    local_data.push({x: new Date(newData[i].eventDate).getTime(), y: parseInt(newData[i].value)});
                }
            }
        }
    }

    return local_data;
}

//Function to set connection state depending last temperature time
const getConnectionState = (TemperatureDataset) => {
    
    let connectionState = "not connected"

    //If last temperatures data are defined
    if((TemperatureDataset !== undefined)&&(TemperatureDataset.length !== 0)){

        let date = new Date();
        let current_Date = new Date(
            date.getFullYear(), 
            date.getMonth(), 
            date.getDate(), 
            date.getHours(), 
            date.getMinutes(), 
            date.getSeconds(), 
            date.getMilliseconds()
        );
        let temperatureDate = new Date(TemperatureDataset[0].eventDate)

        //Comparison between last temperature retrieved date and current date (result in seconds)
        let secondsSinceLastData = ((Math.abs(current_Date - temperatureDate)) / 1000);

        //if last temperature retrieved is less than 180s, then return connection state as "connected"
        if(secondsSinceLastData < 180){
            connectionState = "connected";
        }
        //If last temperature retrieved is between 180s and 500s, then return connection state as "not connected timer"
        else if((secondsSinceLastData >= 180)&&(secondsSinceLastData <= 500)){
            connectionState = "not connected timer";
        }
        //If last temperature retrieved more than 500s, then return connection state as "not connected"
        else{
            connectionState = "not connected";
        }
    }

    return (connectionState);
}


const getLastbatteryAndPosition = (connectionState, batteryDataset, positionDataset) => {
    let local_data = {      
        battery: "-",
        position: "-"            
    }

    if(connectionState === "connected"){                
        if ((batteryDataset != undefined) && (batteryDataset.length>1)){
            local_data.battery = batteryDataset[batteryDataset.length-1].y
        }
        if ((positionDataset != undefined) && (positionDataset.length>1)){
            local_data.position = positionDataset[positionDataset.length-1].y
        }
    }
    return local_data
}




// Function to check if a position alert must be triggered
const checkPositionAlert = (activatedPositionAlerts, dataset) => {

    let currentPosition = ""
    let previous_position = ""

    if (dataset.length >1){         // at least 2 val
        currentPosition = dataset[dataset.length-1].y
        previous_position = dataset[dataset.length-2].y 
    }

    // if position has not changed, no alert to trig
    if(currentPosition === previous_position){
        return false;
    }

    // Verify with SQL param trigger. number of shift depends on current position value (1:stand, 2:back, 3:belly, 4: right edge, 5 left edge, 6: upside down)                       
    if(((activatedPositionAlerts.threshold  >>> (currentPosition-1)) & 1) === 1){
        return true;
    }
    else{
        return false;
    }
}
 


//Const to import functions in other files
const TuckyDataManager = {
  getLastTemperatureDataAndColor,
  formatAndMergeBatorPosData,
  formatAndMergeTemperatureData,
  getConnectionState,
  getLastbatteryAndPosition,
  checkPositionAlert
};

export default TuckyDataManager;

